import axios from "./axiosConfig";

const API_BASE = "/api";

/** Query param used for shareable article deep links on /qa and /editor. */
export const ARTICLE_PARAM = "article";

/** Absolute share URL for a wiki article page (`/qa` or `/editor`). */
export function wikiArticleShareUrl(path, title) {
  const clean = String(title || "").trim();
  if (!clean) return null;
  const params = new URLSearchParams({ [ARTICLE_PARAM]: clean });
  const suffix = path.startsWith("/") ? path : `/${path}`;
  return `${window.location.origin}/wiki${suffix}?${params}`;
}

/** Read trimmed article title from URL search params, or null. */
export function articleTitleFromSearchParams(searchParams) {
  const t = searchParams?.get?.(ARTICLE_PARAM);
  return typeof t === "string" && t.trim() ? t.trim() : null;
}

/** Set or clear the article query param (replace by default). */
export function setArticleSearchParam(setSearchParams, title, { replace = true } = {}) {
  const clean = typeof title === "string" ? title.trim() : "";
  if (clean) {
    setSearchParams({ [ARTICLE_PARAM]: clean }, { replace });
  } else {
    setSearchParams({}, { replace });
  }
}

/** Load manual wiki article by title (query param avoids `/` in titles breaking URL paths). */
export function fetchWikiSection(title) {
  return axios.get(`${API_BASE}/section`, { params: { title } });
}

/** Delete manual wiki article by title. */
export function deleteWikiSection(title) {
  return axios.delete(`${API_BASE}/section`, { params: { title } });
}
